import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Global Trademark Federation';

const PageMeta = ({ title, description }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
    </Helmet>
  );
};

export default PageMeta;
